import React, { Component } from 'react';
import TransportsTable from './Table/TransportsTable';
import TransportsTableEdit from './Edit/TransportsTableEdit';


export class TransportsByLotContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent,
      negotiationLotId: 0
    };
  }

  handleChangeShowContent = (newContent, negotiationLotId) => {
    this.setState({
      content: newContent,
      negotiationLotId: negotiationLotId
    });
  };


  render() {

    return (
      <div>
        {this.state.content === 'transportsByLot' ?
          <TransportsTable handleChangeContent={this.props.handleChangeContent.bind(this)} handleChangeShowContent={this.handleChangeShowContent.bind(this)} />
          : this.state.content === 'transportsByLotEdit' ?
            <TransportsTableEdit handleChangeContent={this.props.handleChangeContent.bind(this)} handleChangeShowContent={this.handleChangeShowContent.bind(this)} negotiationLotId={this.state.negotiationLotId} />
            : null
        }
      </div>
    )

  }
}

export default TransportsByLotContent;


// WEBPACK FOOTER //
// ./src/components/Transports/ByLot/TransportsByLotContent.js